import { SharedState } from '@trello/shared-state';

import type { ReactionModel } from './Reactions.types';

interface PendingUpdate {
  idAction: string;
  reaction: ReactionModel;
  type: 'add' | 'remove';
}

interface ReactionsState {
  pendingUpdates: {
    [idUpdate: string]: PendingUpdate;
  };
  reactions: { [idModel: string]: ReactionModel[] };
}

export const reactionsState = new SharedState<ReactionsState>({
  pendingUpdates: {},
  reactions: {},
});
